import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';
import { ToastContext } from '../App';

function autoFormatDate(val) {
  const digits = val.replace(/\D/g, '');
  if (digits.length <= 2) return digits;
  if (digits.length <= 4) return digits.slice(0,2) + '.' + digits.slice(2);
  return digits.slice(0,2) + '.' + digits.slice(2,4) + '.' + digits.slice(4,8);
}

export default function ConsultationPage() {
  const navigate = useNavigate();
  const showToast = useContext(ToastContext);
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);

  const f = (field, value) => setForm(p => ({...p, [field]: value}));

  const save = async () => {
    if (!form.last_name || !form.first_name) return showToast('Заполните ФИО','error');
    setSaving(true);
    try {
      const body = {...form, name: [form.last_name, form.first_name, form.middle_name].filter(Boolean).join(' ')};
      const { data } = await api.post('/clients', body);
      showToast('Клиент создан');
      navigate('/clients/' + data.id);
    } catch { showToast('Ошибка','error'); }
    setSaving(false);
  };

  return (
    <div>
      <h1 className="page-title" style={{marginBottom:24}}>Новая консультация</h1>
      <div className="card" style={{padding:24}}>
        <h3 style={{fontSize:16,marginBottom:16,color:'var(--accent)'}}>Личные данные</h3>
        <div className="form-row" style={{gridTemplateColumns:'1fr 1fr 1fr'}}>
          <div className="form-group"><label>Фамилия *</label><input className="form-input" value={form.last_name||''} onChange={e=>f('last_name',e.target.value)} /></div>
          <div className="form-group"><label>Имя *</label><input className="form-input" value={form.first_name||''} onChange={e=>f('first_name',e.target.value)} /></div>
          <div className="form-group"><label>Отчество</label><input className="form-input" value={form.middle_name||''} onChange={e=>f('middle_name',e.target.value)} /></div>
        </div>
        <div className="form-row" style={{gridTemplateColumns:'1fr 1fr 1fr'}}>
          <div className="form-group"><label>Прежняя фамилия</label><input className="form-input" value={form.prev_last_name||''} onChange={e=>f('prev_last_name',e.target.value)} /></div>
          <div className="form-group"><label>Прежнее имя</label><input className="form-input" value={form.prev_first_name||''} onChange={e=>f('prev_first_name',e.target.value)} /></div>
          <div className="form-group"><label>Прежнее отчество</label><input className="form-input" value={form.prev_middle_name||''} onChange={e=>f('prev_middle_name',e.target.value)} /></div>
        </div>
        <div className="form-row">
          <div className="form-group"><label>Дата рождения</label><input className="form-input" type="date" value={form.birth_date||''} onChange={e=>f('birth_date',e.target.value)} /></div>
          <div className="form-group"><label>Место рождения</label><input className="form-input" value={form.birth_place||''} onChange={e=>f('birth_place',e.target.value)} /></div>
        </div>
        <div className="form-row" style={{gridTemplateColumns:'1fr 1fr 1fr 1fr'}}>
          <div className="form-group"><label>СНИЛС</label><input className="form-input" value={form.snils||''} onChange={e=>f('snils',e.target.value)} /></div>
          <div className="form-group"><label>ИНН</label><input className="form-input" value={form.inn||''} onChange={e=>f('inn',e.target.value)} /></div>
          <div className="form-group"><label>Телефон</label><input className="form-input" value={form.phone||''} onChange={e=>f('phone',e.target.value)} /></div>
          <div className="form-group"><label>Email</label><input className="form-input" value={form.email||''} onChange={e=>f('email',e.target.value)} /></div>
        </div>

        <h3 style={{fontSize:16,marginBottom:16,marginTop:8,color:'var(--accent)'}}>Паспорт</h3>
        <div className="form-row">
          <div className="form-group"><label>Серия</label><input className="form-input" value={form.passport_series||''} onChange={e=>f('passport_series',e.target.value)} /></div>
          <div className="form-group"><label>Номер</label><input className="form-input" value={form.passport_number||''} onChange={e=>f('passport_number',e.target.value)} /></div>
        </div>

        <h3 style={{fontSize:16,marginBottom:16,marginTop:8,color:'var(--accent)'}}>Адрес регистрации</h3>
        <div className="form-row" style={{gridTemplateColumns:'1fr 1fr 1fr'}}>
          <div className="form-group"><label>Субъект РФ</label><input className="form-input" value={form.reg_subject||''} onChange={e=>f('reg_subject',e.target.value)} /></div>
          <div className="form-group"><label>Район</label><input className="form-input" value={form.reg_district||''} onChange={e=>f('reg_district',e.target.value)} /></div>
          <div className="form-group"><label>Город</label><input className="form-input" value={form.reg_city||''} onChange={e=>f('reg_city',e.target.value)} /></div>
        </div>
        <div className="form-row" style={{gridTemplateColumns:'1fr 1fr 1fr'}}>
          <div className="form-group"><label>Населённый пункт</label><input className="form-input" value={form.reg_settlement||''} onChange={e=>f('reg_settlement',e.target.value)} /></div>
          <div className="form-group"><label>Улица</label><input className="form-input" value={form.reg_street||''} onChange={e=>f('reg_street',e.target.value)} /></div>
          <div className="form-group"><label>Дом</label><input className="form-input" value={form.reg_house||''} onChange={e=>f('reg_house',e.target.value)} /></div>
        </div>
        <div className="form-row">
          <div className="form-group"><label>Корпус</label><input className="form-input" value={form.reg_building||''} onChange={e=>f('reg_building',e.target.value)} /></div>
          <div className="form-group"><label>Квартира</label><input className="form-input" value={form.reg_apartment||''} onChange={e=>f('reg_apartment',e.target.value)} /></div>
        </div>

        <h3 style={{fontSize:16,marginBottom:16,marginTop:8,color:'var(--accent)'}}>Банк</h3>
        <div className="form-row">
          <div className="form-group"><label>Наименование банка</label><input className="form-input" value={form.bank_name||''} onChange={e=>f('bank_name',e.target.value)} /></div>
          <div className="form-group"><label>БИК</label><input className="form-input" value={form.bank_bik||''} onChange={e=>f('bank_bik',e.target.value)} /></div>
        </div>

        <h3 style={{fontSize:16,marginBottom:16,marginTop:8,color:'var(--accent)'}}>Доверенность</h3>
        <div className="form-row">
          <div className="form-group"><label>Дата выдачи</label><input className="form-input" placeholder="ДД.ММ.ГГГГ" maxLength={10} value={form.dov_date||''} onChange={e=>f('dov_date',autoFormatDate(e.target.value))} /></div>
          <div className="form-group"><label>Серия и номер</label><input className="form-input" value={form.dov_number||''} onChange={e=>f('dov_number',e.target.value)} /></div>
        </div>

        <div className="form-group"><label>Заметки</label><textarea className="form-textarea" value={form.notes||''} onChange={e=>f('notes',e.target.value)} /></div>

        <div style={{marginTop:16}}>
          <button className="btn btn-primary" onClick={save} disabled={saving}>{saving ? 'Сохранение...' : 'Создать клиента'}</button>
        </div>
      </div>
    </div>
  );
}
